module.exports = function getResource(label, vars = []) {
    const resources = {
        limitedSupply: 'Stock limité',
        goingFast: 'Produits qui partent vite',
        signInToAccess: 'Accéder au compte',
        addFullSize: 'Ajouter le produit en format standard',
        addToBasket: `Ajouter${!vars[0] ? ' au panier' : ''}`,
        remove: 'Supprimer',
        writeAReview: 'Rédiger une évaluation',
        free: 'GRATUIT',
        birthday: 'cadeau d’anniversaire',
        priceInPoints: `${vars[0]} points`
    };

    return resources[label];
};
